import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";

const ForbiddenPage = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate('/dashboard');
  };

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 px-6">
      <div className="max-w-md w-full text-center">
        {/* Error Icon */}
        <div className="flex justify-center mb-6">
          <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center">
            <svg
              className="w-8 h-8 text-red-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728L5.636 5.636m12.728 12.728L18.364 5.636M5.636 18.364l12.728-12.728"
              />
            </svg>
          </div>
        </div>

        {/* Title */}
        <h1 className="text-2xl font-bold text-gray-900 mb-4">
          Access Denied
        </h1>

        {/* Description */}
        <p className="text-gray-600 mb-8 leading-relaxed">
          You don't have permission to access this resource. Please contact your administrator
          if you believe this is an error, or try accessing a different section.
        </p>

        {/* Action Buttons */}
        <div className="space-y-3 sm:space-y-0 sm:space-x-3 sm:flex sm:justify-center">
          <Button
            onClick={handleGoBack}
            className="w-full sm:w-auto bg-blue-600 hover:bg-blue-700 text-white"
          >
            Go to Dashboard
          </Button>
          <Button
            onClick={handleGoHome}
            variant="outline"
            className="w-full sm:w-auto"
          >
            Go Home
          </Button>
        </div>

        {/* Additional Info */}
        <div className="mt-12 text-sm text-gray-500">
          Error Code: 403 - Forbidden
        </div>
      </div>
    </div>
  );
};

export default ForbiddenPage;